import React from "react";

const Loader = ({ className }) => (
  <div className={`loader ${className}`}>
    <img src="/assets/images/cop_loading.gif" alt="loader" />
  </div>
);
export default Loader;
